export default "__VITE_PUBLIC_ASSET__951a417d__"